
import { IConfig} from './types';
import {getEnvVariables} from "../utils/getEnv";
const { REACT_APP_BACKEND, REACT_APP_CLIENT_SECRET,REACT_APP_CLIENT_ID} = getEnvVariables();



// Configuración única basada en las variables del .env actual
const BASE_CONFIG: IConfig = {
    base:'',
    backend: `https://${REACT_APP_BACKEND}`, // Usa la variable del .env cargado
    credential: {
        clientSecret: REACT_APP_CLIENT_SECRET || "",
        clientId: REACT_APP_CLIENT_ID || "",
    }
};

export default BASE_CONFIG;



